import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {IProdFormService} from 'prod-form';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';
import {Organization} from "../models/organization";
import {HttpClient} from "@angular/common/http";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";

@Injectable({
  providedIn: 'root'
})
export class SiteService extends AbstractProdSelectService implements IProdGridService, IProdFormService {
  override selectDataUrl: string = 'organizations';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'name'
  };

  constructor(public override httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
    super(httpClient);
  }

  get(id: number) {
    return this.httpClient.get<{ data: Organization, success: boolean }>(`/api/organization/${id}`);
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: Organization[], totalCount: number }, success: boolean }>(`/api/organizations`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/organization`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch(`/api/organization/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    return this.httpClient.delete(`/api/organization/${id}`);
  }

  getOrganizationFilter(): HttpFilterParam[] {
    return [new HttpFilterParam({
      property: 'organization.id',
      operator: 'eq',
      value: this.organizationTreeSelect.company.id
    })];
  }
}
